import { Link } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import React from "react"

export default function NavLessons(props) {
  const intl = useIntl()
  // const module = props.module
  const urlPrevious = `../notion-${parseInt(props.grainId,10) - 1}`
  const urlNext = `../notion-${parseInt(props.grainId,10) + 1}`
  return (
    <nav className="content--main lessonsNav">
      <div>
        {props.grainId !== 1 && (
          <Link to={urlPrevious}>
            ◀ {intl.formatMessage({ id: "training17" })}
          </Link>
        )}
      </div>
      <div>
        {props.grainId !== 100 && (
          <Link to={urlNext}>{intl.formatMessage({ id: "training18" })} ▶</Link>
        )}
      </div>
    </nav>
  )
}
